/** Discover → Prompts (AUTO-8). Includes preview support. */

import { createFileRoute } from '@tanstack/react-router';
import { MessageSquare } from 'lucide-react';
import { CatalogBrowsePage } from '@/components/discover/catalog-browse-page';

export const Route = createFileRoute('/admin/discover/prompts')({
  component: DiscoverPromptsPage,
});

function DiscoverPromptsPage() {
  return (
    <CatalogBrowsePage
      kind="prompt"
      title="Prompts"
      description="Reusable LLM prompt templates with named variables. Click any prompt to see the template and preview it against argus_fast with your own sample inputs."
      icon={MessageSquare}
      showPreview
    />
  );
}
